module.exports = __webpack_public_path__ + "img/ball_3.c9a4b3dd.svg";